











import { Component, Vue } from "vue-property-decorator";

@Component
export default class Search extends Vue {
  query: string = "";
  constructor(props: any) {
    super(props);
  }
  onInputChange(event: InputEvent) {
    this.query = (event.target as HTMLInputElement).value;
    this.$emit("on-search", this.query.toLowerCase());
  }
}
